import { render, staticRenderFns } from "./VisioCredentials.vue?vue&type=template&id=27533599"
import script from "./VisioCredentials.vue?vue&type=script&lang=ts"
export * from "./VisioCredentials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports